"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryVehicleByPimCode = void 0;
const legacy_queries_1 = require("./legacy-queries");
exports.queryVehicleByPimCode = `
  query vehicleByPimCode($pimCode: ID!) {
    vehicleByPimCode(pimCode: $pimCode) {
      id
      accessories {
        id
        customerPrice
        images {
          url
        }
        manufacturer
        margin
        name
        price
        priceExcludingVat
        sku
      }
      model {
        equipment {
          equipment
        }
        fuel {
          name
          type
        }
        powerTrain
        effect
        electricProps {
          batteryCapacity
          chargingCapacityAC
          chargingCapacityDC
          electricRange
        }
        make
        name
        salesArticle
        series
        vehicleType
        year
        pricing {
          importerSupport
          deliveryCharge
          oneTimeFee
          wreckage
          source
          importerSupportExcludingVat
          deliveryChargeExcludingVat
          wreckageExcludingVat
        }
      }
      price
      priceExcludingVat
      pricing {
        ${legacy_queries_1.allPricingFields}
      }
      salesPackages {
        additionalPrice
        id
        name
        equipment 
      }
      sku
      tires {
        additionalPrice
        additionalPriceExcludingVat
        description
        id
        isRecommended
        name
        nobos
        rimManufacturer
        tireManufacturer
        type
        vat
      }
    }
  }
`;
//# sourceMappingURL=query-vehicle-by-pim-code.js.map